<div class="terms-container">

  <h1>Termos de Uso</h1>
  <p><strong>Última atualização:</strong> {{lastUpdate}}</p>

  <p>
    Bem-vindo à plataforma <strong>{{appName}}</strong>, um serviço de armazenamento
    e gerenciamento de arquivos em nuvem.
  </p>

  <p>
    Ao utilizar nossos serviços, você concorda com os presentes <strong>Termos de Uso</strong>.
    Caso não concorde com qualquer condição aqui estabelecida, recomendamos que não utilize a plataforma.
  </p>

  <hr />

  <h2>1. Descrição do Serviço</h2>

  <p>
    A <strong>{{appName}}</strong> oferece um sistema de armazenamento digital que permite
    aos usuários salvar, organizar, compartilhar e gerenciar arquivos através da internet.
  </p>

  <hr />

  <h2>2. Responsabilidade pelos Arquivos</h2>

  <p>
    Todos os arquivos armazenados na plataforma são de inteira responsabilidade do usuário que os enviou.
  </p>

  <p>O usuário declara que:</p>

  <ul>
    <li>Possui os direitos necessários sobre os arquivos enviados</li>
    <li>Não está violando direitos autorais ou propriedade intelectual</li>
    <li>Não está utilizando o sistema para distribuição de conteúdo ilegal ou malicioso</li>
  </ul>

  <p>
    A <strong>{{appName}}</strong> não se responsabiliza pelo conteúdo armazenado pelos usuários.
  </p>

  <hr />

  <h2>3. Conteúdo Proibido</h2>

  <p>É proibido armazenar, distribuir ou compartilhar arquivos que:</p>

  <ul>
    <li>Contenham malware, vírus, ransomware ou códigos maliciosos</li>
    <li>Violem leis locais, nacionais ou internacionais</li>
    <li>Infrinjam direitos autorais ou propriedade intelectual</li>
    <li>Contenham conteúdo ilegal ou ilícito</li>
    <li>Sejam utilizados para fraudes, phishing ou atividades criminosas</li>
  </ul>

  <p>A violação destas regras poderá resultar em:</p>

  <ul>
    <li>Remoção do conteúdo</li>
    <li>Suspensão da conta</li>
    <li>Encerramento definitivo do acesso</li>
    <li>Comunicação às autoridades competentes, quando necessário</li>
  </ul>

  <hr />

  <h2>4. Monitoramento e Segurança</h2>

  <p>
    Para garantir a segurança da plataforma, a <strong>{{appName}}</strong>
    utiliza sistemas automatizados de segurança, incluindo:
  </p>

  <ul>
    <li>Sistemas antivírus e detecção de ameaças</li>
    <li>Verificação de assinaturas digitais e hashes de arquivos</li>
    <li>Análise automatizada para identificação de conteúdo malicioso</li>
  </ul>

  <p>
    Arquivos identificados como potencialmente maliciosos ou ilegais poderão
    ser removidos automaticamente, sem aviso prévio ou consentimento do usuário,
    visando proteger a infraestrutura e demais usuários.
  </p>

  <hr />

  <h2>5. Proteção e Criptografia de Dados</h2>

  <p>
    A plataforma utiliza práticas adequadas de segurança, incluindo:
  </p>

  <ul>
    <li>Criptografia de dados</li>
    <li>Protocolos seguros de transmissão</li>
    <li>Controles de acesso</li>
  </ul>

  <p>
    Embora sejam adotadas medidas de segurança, nenhum sistema é completamente
    imune a falhas, e o usuário concorda que utiliza o serviço por sua conta e risco.
  </p>

  <hr />

  <h2>6. Backup de Arquivos</h2>

  <p>
    A responsabilidade pela manutenção de cópias de segurança (backup)
    dos arquivos é exclusivamente do usuário.
  </p>

  <p>
    A <strong>{{appName}}</strong> não garante retenção permanente de dados
    e não se responsabiliza por:
  </p>

  <ul>
    <li>Perda de arquivos</li>
    <li>Corrupção de dados</li>
    <li>Exclusões acidentais</li>
    <li>Falhas técnicas ou operacionais</li>
  </ul>

  <p>
    Recomendamos fortemente que o usuário mantenha backup local
    ou em outros serviços.
  </p>

  <hr />

  <h2>7. Disponibilidade do Serviço</h2>

  <p>
    A plataforma pode passar por manutenções programadas,
    atualizações de segurança ou interrupções temporárias.
  </p>

  <p>
    A <strong>{{appName}}</strong> não garante disponibilidade contínua
    ou ininterrupta do serviço.
  </p>

  <hr />

  <h2>8. Suspensão ou Encerramento de Conta</h2>

  <p>
    A conta de um usuário pode ser suspensa ou encerrada em caso de:
  </p>

  <ul>
    <li>Violação destes Termos de Uso</li>
    <li>Atividades consideradas abusivas ou ilegais</li>
    <li>Risco à segurança da plataforma</li>
  </ul>

  <hr />

  <h2>9. Alterações nos Termos</h2>

  <p>
    Estes termos podem ser atualizados periodicamente.
  </p>

  <p>
    A continuidade no uso do serviço após alterações constitui
    aceitação automática dos novos termos.
  </p>

  <hr />

  <h2>10. Contato</h2>

  <p>
    Para dúvidas, solicitações ou denúncias relacionadas ao uso da plataforma:
  </p>

  <p>
    <strong>Sistema:</strong> {{appName}} <br />
    <strong>Email:</strong> {{contactEmail}}
  </p>

</div>